// import { EditFilled } from '@ant-design/icons';
// const icons = { EditFilled };

// const orders = (roleID) => {
//   return roleID == 1
//     ? {
//         id: 'group-orders',
//         title: 'Orders',
//         type: 'group',
//           children: [
//           {
//             id: 'SalesOrderApproval',
//             title: 'Sales Order Approval',
//             type: 'item',
//             url: '/sales-order-approval',
//             icon: icons.EditFilled,
//             breadcrumbs: false
//           }
//         ]
//       }
//     : {
//         id: 'group-orders',
//         title: '',
//         type: 'group',
//         children: []
//       };
// };

// export default orders;



// // assets
// import { FileProtectOutlined,CarOutlined,FieldTimeOutlined, EditFilled} from '@ant-design/icons';

// // icons<FieldTimeOutlined />
// const icons = {
//   FileProtectOutlined,
//   CarOutlined,
//   FieldTimeOutlined,
//   EditFilled
// };

// // ==============================|| MENU ITEMS - Orders ||============================== //

// const orders= {
//   id: 'group-orders',
//   title: 'Orders',
//   type: 'collapse',
//   icon: icons.FileProtectOutlined,
//   children: [
   
//     {
//       id: 'SalesOrderApproval',
//       title: 'Sales Order Approval',
//       type: 'item',
//       url: '/sales-order-approval',
//       icon: icons.EditFilled,
//       breadcrumbs: false
//     }
//   ]
// };

// export default orders;




import { FileProtectOutlined, EditFilled } from '@ant-design/icons';

const icons = { FileProtectOutlined, EditFilled };
const roles = [0,1,2];

const orders = {
  id: 'group-orders',
  title: 'Orders',
  type: 'collapse',
  icon: icons.FileProtectOutlined,
  roles,
  children: [
    {
      id: 'SalesOrderApproval',
      title: 'Sales Order Approval',
      type: 'item',
      url: '/sales-order-approval',
      icon: icons.EditFilled,
      breadcrumbs: false,
      roles
    }
  ]
};

export default orders;
